"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var appendPath_1 = __importDefault(require("./appendPath"));
var getValueFromIndicies_1 = __importDefault(require("./getValueFromIndicies"));
var getValue_1 = __importDefault(require("./getValue"));
/**
 * Retrieves the value from an array based on the provided segment.
 * @param {unknown} value - The value to search within (typically an array or object).
 * @param {string} segment - The segment representing the array and index (e.g., 'array[0]').
 * @param {string | undefined} currentPath - The current path in the object hierarchy.
 * @param {string} path - The full path in the object hierarchy.
 * @returns {unknown} The value retrieved from the array based on the segment.
 * @example // Example usage
 * const value = { a: [ 'b', ['c', 'd', ['e', 'f', 'g']]] }
 * const path = 'parent.a[1][2][3].length';
 * const currentPath = 'parent';
 * const segment = 'a[1][2][3]';
 * console.log(getArrayValue(data, segment, currentPath, path));
 * // Output: "g"
 */
var getArrayValue = function (value, segment, currentPath, path) {
    // Find the index of where the indicies begin
    var index = segment.indexOf("[");
    // Check to see if the segment begins with a key
    if (index !== 0) {
        // Get the key name before the indicies
        var key = segment.slice(0, index);
        // Update the path
        currentPath = (0, appendPath_1.default)(currentPath, key);
        // Grab the value
        value = (0, getValue_1.default)(value, key, currentPath, path);
        // quit if we have nothing
        if (value === undefined)
            return value;
        // Update the segment to remove the key
        segment = segment.slice(index);
    }
    // Return the value from indicies "[0][1]...[n]"
    return (0, getValueFromIndicies_1.default)(value, segment, currentPath, path);
};
exports.default = getArrayValue;
